import { AxiosResponse } from "axios";
import { Result } from "../models/common/resultResponse";
import { KeyValue } from "../models/common";
import { IDeliveryTypeApi } from "./base/deliveryTypeApi";
import { api } from "./base";

const baseRoute: string = "DeliveryType";

export class DeliveryTypeApi extends IDeliveryTypeApi {
	getByDeliveryType(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
